// TODO refactor answer entity as separate with random id


import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import {arrayToMap, dataURLtoFile, updateSortCB} from '../helpers/common'
import RestService from '../helpers/RestService'
import { SubmissionError } from 'redux-form'
import {
    categoriesTreeMapSelector, checkedCategoriesIdsSelector, categorySelector, /*CATEGORIES_ENTITIES_DELETE,*/
    categoriesCursorSelector, massCategoriesSuccess, categoryWithTrashedSelector, allCategoriesTreeMapSelector, checkedCategoriesSelector
} from './categories'
import {getRenderAnswers, MIN_ANSWERS_COUNT, populateStoreKeysFromMinLength, canIncrementAnswers, getFilledAnswersCount, getAnswersForSave, checkQuestionBeforeSave, handleQuestionSaveError, handleUpdateLastSavedQuestionData, getAnswersData, decodeAnswers, removePrefixCatSubcatId, prepareNewQuestionForStore, getNewQuestionFromGetRepsonse, DISABLED, ENABLED, _getId, _getIds, _trashedScopeCB, _isTrashed, _isTemp, _getEntity, _getEntityWithTrashed,_getEntityWithTemp, _entities, _entitiesWithTrashed, getSubjectIdFromTrashResponse, setPrefixToCatSubcatId, sortQuestionsCB, massQuestionsStatusKeysChangeThen} from './_utils'
import {sourcesCursorSelector, massSourcesSucces} from './sources'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import {CONFIRM, hideModal, INFO, INFO_TYPE_ERROR, INFO_TYPE_INFO, showModal, TRASHED_QUESTION_MODAL,TEMP_QUESTION_MODAL, qLoaderShowModal, qLoaderHideModal} from './modals'
import {sortCB, formatErrorMessage, middleThen, middleReduxFormThen, successModalThen, errorModalCatch} from '../helpers/common'
import GarbageButton from '../_static/images/GarbageButton.svg'
import GreenButton from '../_static/images/GreenButton.svg'
import RedButton from '../_static/images/RedButton.svg'
import BlueButton from '../_static/images/BlueButton.svg'
import {currentSubjectSelector} from "./subjects"
import {
    usedId as usedMassActionId,
    unusedId as unusedMassActionId,
    readyForUseId as readyForUseMassActionId,
    checkedUsedId as checkedUsedMassActionId,
    checkedUnusedId as checkedUnusedMassActionId,
    checkedReadyForUseId as checkedReadyForUseMassActionId,
    hideCheckedAnswersId as hideCheckedAnswersMassActionId,
    showCheckedAnswersId as showCheckedAnswersMassActionId,
    hideCheckedExplanationId as hideCheckedExplanationMassActionId,
    showCheckedExplanationId as showCheckedExplanationMassActionId,
    getConfirmationText,
    getSuccesMsg,
} from '../helpers/questionsMenu'
import { getStatus } from '../helpers/menu'
import {importQtizipId, exportQtizipId, exportMspowerpointId, exportDocxId, exportPdfId} from '../helpers/importExport'
import {ajaxUrls} from '../settings/routes'
import {checkAndUploadSources} from "./sources";
import thunkMiddleware from 'redux-thunk'
import { cloneDeep } from 'lodash'

/**
 * Constants
 * */
export const moduleName = 'questions'
const prefix = `${appName}/${moduleName}`

export const QUESTIONS_START = `${prefix}/QUESTIONS_START`
export const QUESTIONS_SUCCESS = `${prefix}/QUESTIONS_SUCCESS`
export const QUESTIONS_FAIL = `${prefix}/QUESTIONS_FAIL`

export const CHANGE_QUESTION_BODY = `${prefix}/CHANGE_QUESTION_BODY`
export const CHANGE_QUESTION_DIFFICULTY = `${prefix}/CHANGE_QUESTION_DIFFICULTY`
export const CHANGE_QUESTION_DESCRIPTION = `${prefix}/CHANGE_QUESTION_DESCRIPTION`
export const QUESTION_CHANGE_CATEGORY = `${prefix}/QUESTION_CHANGE_CATEGORY`
export const SET_CORRECT_ANSWER = `${prefix}/SET_CORRECT_ANSWER`
export const CHANGE_ANSWER = `${prefix}/CHANGE_ANSWER`
export const CHANGE_ANSWERS_DATA = `${prefix}/CHANGE_ANSWERS_DATA`
export const INCREMENT_ANSWERS_COUNT = `${prefix}/INCREMENT_ANSWERS_COUNT`
export const DECREMENT_ANSWERS_COUNT = `${prefix}/DECREMENT_ANSWERS_COUNT`

export const UPLOADING_IMG_START = `${prefix}/UPLOADING_IMG_START`
export const UPLOADING_IMG_SUCCESS = `${prefix}/UPLOADING_IMG_SUCCESS`
export const UPLOADING_IMG_FAIL = `${prefix}/UPLOADING_IMG_FAIL`
export const UPLOADING_IMG_RESET = `${prefix}/UPLOADING_IMG_RESET`

export const NEW_FORM_TEMP_IMG = `${prefix}/NEW_FORM_TEMP_IMG`
export const CLEAR_NEW_FORM_TEMP_IMG = `${prefix}/CLEAR_NEW_FORM_TEMP_IMG`

export const QUESTION_FORM_STATE = `${prefix}/QUESTION_FORM_STATE`
export const QUESTION_FORM_ERRORS = `${prefix}/QUESTION_FORM_ERRORS`
export const QUESTION_FORM_RESET = `${prefix}/QUESTION_FORM_RESET`

export const QUESTION_CHANGE_QUESTION_DATA = `${prefix}/QUESTION_CHANGE_QUESTION_DATA`
export const QUESTION_CHANGE_QUESTION_STATISTIC_ANSWER = `${prefix}/QUESTION_CHANGE_QUESTION_STATISTIC_ANSWER`

export const QUESTION_TOGGLE_OPEN_STATE = `${prefix}/QUESTION_TOGGLE_OPEN_STATE`
export const QUESTIONS_MASS_OPEN_STATE = `${prefix}/QUESTIONS_MASS_OPEN_STATE`

export const QUESTION_NEW_FORM = `${prefix}/QUESTION_NEW_FORM`
export const QUESTION_COPY_FORM = `${prefix}/QUESTION_COPY_FORM`

export const QUESTION_DELETE = `${prefix}/QUESTION_DELETE`
export const QUESTIONS_MASS_DELETE = `${prefix}/QUESTIONS_MASS_DELETE`


export const QUESTION_SUCCESS_CREATE = `${prefix}/QUESTION_SUCCESS_CREATE`
export const QUESTIONS_STATUSES_CHANGE = `${prefix}/QUESTIONS_STATUSES_CHANGE`

export const QUESTION_CHANGE_QUESTION_SOURCE = `${prefix}/QUESTION_CHANGE_QUESTION_SOURCE`
export const QUESTION_CHANGE_COMMENTS = `${prefix}/QUESTION_CHANGE_COMMENTS`
export const QUESTION_REMOVE_COMMENTS = `${prefix}/QUESTION_REMOVE_COMMENTS`
export const QUESTION_CHANGE_QUESTION_CATEGORY = `${prefix}/QUESTION_CHANGE_QUESTION_CATEGORY`

export const TRASHED_QUESTIONS_START = `${prefix}/TRASHED_QUESTIONS_START`
export const TRASHED_QUESTIONS_SUCCESS = `${prefix}/TRASHED_QUESTIONS_SUCCESS`
export const TRASHED_QUESTIONS_FAIL = `${prefix}/TRASHED_QUESTIONS_FAIL`

export const TEMP_QUESTIONS_START = `${prefix}/TEMP_QUESTIONS_START`
export const TEMP_QUESTIONS_SUCCESS = `${prefix}/TEMP_QUESTIONS_SUCCESS`
export const TEMP_QUESTIONS_FAIL = `${prefix}/TEMP_QUESTIONS_FAIL`
export const TEMP_QUESTIONS_CURSOR = `${prefix}/TEMP_QUESTIONS_CURSOR`
export const TEMP_QUESTIONS_RECOVER = `${prefix}/TEMP_QUESTIONS_RECOVER`
export const CLEAR_TEMP_QUESTINS = `${prefix}/CLEAR_TEMP_QUESTINS`

export const PUT_QUESTIONS_TO_TRASH = `${prefix}/PUT_QUESTIONS_TO_TRASH`
export const TRASHED_QUESTIONS_CURSOR = `${prefix}/TRASHED_QUESTIONS_CURSOR`
export const TRASHED_QUESTIONS_RECOVER = `${prefix}/TRASHED_QUESTIONS_RECOVER`
export const CLEAR_TRASHED_QUESTINS = `${prefix}/CLEAR_TRASHED_QUESTINS`

export const GENERAL_STATISTIC_START = `${prefix}/GENERAL_STATISTIC_START`
export const GENERAL_STATISTIC_SUCCESS = `${prefix}/GENERAL_STATISTIC_SUCCESS`
export const GENERAL_STATISTIC_FAIL = `${prefix}/GENERAL_STATISTIC_FAIL`

export const IMPORT_QUESTIONS_SUCCESS = `${prefix}/IMPORT_QUESTIONS_SUCCESS`


/*
 -- disabled - 0
 -- ready for export + wasn't exported before - 1 (зеленый)
 -- ready for export + was exported before - 2 (красный)
 -- not ready for export + wasn't exported before - 3 (зеленый)
 -- not ready for export + was exported before - 4 (белый)
 -- can be recovered - 5
 * */
export const QUESTION_STATUSES = {
    0 : {
        status : DISABLED,
        text : 'disable',
        color : "#fff",
        label : "Remove question",
        imgSrc : GarbageButton,
        order : 0,
        statisticIconClassSuffix : "icon-grey",
        inStatistic : false,
    },
    1 : {
        status : 1,
        text : 'ready',
        color : "rgba(103,212,103,0.3)",
        label : 'Mark as "Ready for use"',
        imgSrc : GreenButton,
        order : 1,
        statisticIconClassSuffix : "icon-success",
        inStatistic : true,
    },
    2 : {
        status : 2,
        text : 'not used',
        color : "#fff",
        label : 'Mark as "Unused"',
        imgSrc : BlueButton,
        order : 3,
        statisticIconClassSuffix : "icon-white",
        inStatistic : true,
    },
    3 : {
        status : 3,
        text : 'used',
        color : "rgba(212,103,103,0.2)",
        label : 'Mark as "Used"',
        imgSrc : RedButton,
        order : 2,
        statisticIconClassSuffix : "icon-danger",
        inStatistic : true,
    },
    4 : {
        status : 4,
        text : 'temp',
        color : "rgba(255,255,0,0.2)",
        label : 'Temp',
        imgSrc : RedButton,
        order : 4,
        statisticIconClassSuffix : "icon-temp",
        inStatistic : true,
    }
}

export const MAX_IMG_IN_QUESTION_EDITOR = 3


/**
 * Reducer
 * */

export const formStateRecord = Record({
    isTouched : false,
})

export const formErrorsRecord = Record({
    answers : [],
    body : [],
    backend : [],
    recover : [],
    removeErr : [], // collision with Record property remove
})

export const formRecord = Record({
    state : new formStateRecord(),
    errors : new formErrorsRecord(),
})

export const answerT1Record = Record({
    answer_1 : "",
    answer_2 : "",
    answer_3 : "",
    answer_4 : "",
    answer_5 : "",
    answer_6 : "",
    answer_7 : "",
    answer_8 : "",
    answer_9 : "",
    answer_10 : "",
    correct_answer : null,

    _ls_answer_1 : "",
    _ls_answer_2 : "",
    _ls_answer_3 : "",
    _ls_answer_4 : "",
    _ls_answer_5 : "",
    _ls_answer_6 : "",
    _ls_answer_7 : "",
    _ls_answer_8 : "",
    _ls_answer_9 : "",
    _ls_answer_10 : "",
    _ls_correct_answer : "",
})

const _defaultEditorContent = "<p></p>"
export const questionRecord = Record({
    id : null,
    body : _defaultEditorContent,
    _ls_body : _defaultEditorContent,
    description : _defaultEditorContent,
    _ls_description : _defaultEditorContent,
    category_id : null, // could be category or subcategory
    source_id : null,

    subject_id : null,

    status : QUESTION_STATUSES[2].status, // @see QUESTION_STATUSES
    _ls_status : QUESTION_STATUSES[2].status,

    created_at : null,
    updated_at : null,
    answerT1 : new answerT1Record(),
    answersCount : MIN_ANSWERS_COUNT,
    answersIsOpen : true,
    descriptionIsOpen : true,
    difficulty: 0,
    labels: [],
    token: '',
    comments: [],
    answ_state : 1,
    expl_state : 1,
    comment_state : 0,

    uploadingImg : false,
    uploadImgFail : false,

    form : new formRecord(),

    isNewForm : false,
    isCopyed: false,
    realCategory: null,
    subcategory_id: null,
    newFormImg : {},
    additional: false,
    statistic: null,
})

const statisticItemRecord = Record({
    status : null,
    count : null,
    iconSuffix : null
})

const questionComment = Record({
    id : null,
    user_id : null,
    question_id : null,
    text : null
})

const statisticRecord = Record({
    loading : false,
    loaded : false,
    entities : arrayToMap([], statisticItemRecord, 'status')
})

export const ReducerRecord = Record({
    entities : arrayToMap([], questionRecord),
    trashedCursor : null,
    trashedLoading : false,
    trashedLoaded : false,
    tempCursor : null,
    tempLoading : false,
    tempLoaded : false,
    generalStatistic : new statisticRecord(),
})

const defaultState = new ReducerRecord();

export default function reducer(state = defaultState, action) {
    const {type, payload} = action
    switch (type) {
        case QUESTIONS_SUCCESS : {
            const {questions = []} = payload
            questions.forEach(question => {
                const {id, answerT1, ...rest} = question
                state = state.setIn(['entities', id], new questionRecord({
                    id,
                    answerT1 : new answerT1Record({...answerT1}),
                    ...rest,
                }))
            })
            return state
            break
        }
        case CHANGE_QUESTION_BODY : {
            const {questionId, editorState} = payload
            return state.setIn(['entities', questionId, 'body'], editorState)
            break
        }
        case CHANGE_QUESTION_DIFFICULTY : {
            const {questionId, editorState} = payload
            return state.setIn(['entities', questionId, 'difficulty'], editorState)
            break
        }
        case CHANGE_QUESTION_DESCRIPTION : {
            const {questionId, editorState} = payload
            return state.setIn(['entities', questionId, 'description'], editorState)
            break
        }
        case SET_CORRECT_ANSWER : {
            const {questionId, storeKey, isCorrect = true} = payload
            return state.setIn(['entities', questionId, 'answerT1', 'correct_answer'], isCorrect ? storeKey : null)
            break
        }
        case CHANGE_ANSWER : {
            const {questionId, storeKey, value} = payload
            return state.setIn(['entities', questionId, 'answerT1', storeKey], value)
            break
        }
        case INCREMENT_ANSWERS_COUNT : {
            const {questionId} = payload
            return state.updateIn(['entities', questionId, 'answersCount'], answersCount => answersCount + 1)
            break
        }
        case DECREMENT_ANSWERS_COUNT : {
            const {questionId} = payload
            return state.updateIn(['entities', questionId, 'answersCount'], answersCount => answersCount - 1)
            break
        }
        case QUESTION_CHANGE_QUESTION_DATA : {
            const {questionId, questionData = []} = payload
            questionData.forEach(qd => {
                const {key, value} = qd
                state = state.setIn(['entities', questionId, key], value)
            })
            return state
            break
        }
        case QUESTION_CHANGE_QUESTION_STATISTIC_ANSWER : {
            const {questionId, questionData = []} = payload
            questionData.forEach(qd => {
                const {key, value} = qd
                state = state.setIn(['entities', questionId, key], value)
            })
            return state
            break
        }
        case CHANGE_ANSWERS_DATA : {
            const {questionId, answersData = []} = payload
            return state.updateIn(['entities', questionId, 'answerT1'], answerT1 => {
                answersData.forEach(answD => {
                    const {key, value} = answD
                    answerT1 = answerT1.set(key, value)
                })
                return answerT1
            })
            break
        }
        case UPLOADING_IMG_START : {
            const {questionId} = payload
            return state.setIn(['entities', questionId, 'uploadingImg'], true)
        }
        case UPLOADING_IMG_SUCCESS : {
            const {questionId} = payload
            return state.updateIn(['entities', questionId], question => question.set('uploadingImg', false).set('uploadImgFail', false))
            break
        }
        case UPLOADING_IMG_FAIL : {
            const {questionId} = payload
            return state.updateIn(['entities', questionId], question => question.set('uploadImgFail', true).set('uploadingImg', false))
            break
        }
        case UPLOADING_IMG_RESET : {
            const {questionId} = payload
            return state.updateIn(['entities', questionId], question => question.set('uploadImgFail', false).set('uploadingImg', false))
            break
        }
        case NEW_FORM_TEMP_IMG : {
            const {questionId, base64, imgFile, editorType} = payload
            const {name} = imgFile
            return state.updateIn(['entities', questionId, 'newFormImg'], newFormImg => {
                return {
                    ...newFormImg,
                    [editorType] : {
                        ...newFormImg[editorType],
                        [name] : {
                            base64,
                            imgFile,
                        },
                    }
                }
            })
            break
        }
        case CLEAR_NEW_FORM_TEMP_IMG : {
            const {questionId} = payload
            return state.updateIn(['entities', questionId, 'newFormImg'], newFormImg => ({}))
            break
        }
        case QUESTION_FORM_STATE : {
            const {questionId, stateData = []} = payload
            stateData.forEach(sd => {
                const {key, value} = sd
                state = state.setIn(['entities', questionId, 'form', 'state', key], value)
            })
            return state
            break
        }
        case QUESTION_FORM_ERRORS : {
            const {questionId, errorsData = []} = payload
            errorsData.forEach(ed => {
                const {key, value} = ed
                state = state.setIn(['entities', questionId, 'form', 'errors', key], value)
            })
            return state
            break
        }
        case QUESTION_FORM_RESET : {
            const {questionId} = payload
            return state.setIn(['entities', questionId, 'form'], new formRecord())
            break
        }
        case QUESTION_TOGGLE_OPEN_STATE : {
            const {questionId, toggleKey} = payload
            return state.updateIn(['entities', questionId], question => {
                if (!question.has(toggleKey)) return question
                return question.update(toggleKey, currentKey => +!currentKey)
            })
            break
        }
        case QUESTIONS_MASS_OPEN_STATE : {
            const {changeData} = payload
            changeData.forEach(chD => {
                const {questionId, toggleKey, toggleValue} = chD
                state = state.updateIn(['entities', questionId], question => {
                    if (!question.has(toggleKey)) return question
                    return question.set(toggleKey, toggleValue)
                })
            })
            return state
            break
        }
        case QUESTION_NEW_FORM : {
            const {randomId, initData : {category_id, source_id, subject_id}} = payload
            let rec = new questionRecord({id : randomId, category_id, source_id, subject_id, isNewForm : true})
            return state.setIn(['entities', randomId], rec)
            break
        }
        case QUESTION_COPY_FORM : {
            const {
                randomId,
                initData : {
                    tempId,
                    category_id,
                    subject_id,
                    subcategory_id,
                    source_id,
                    oldOne,
                    real_category
                }
            } = payload
            let rec = new questionRecord({
                id : tempId,
                //answ_state : oldOne.answ_state,
                answerT1 : oldOne.answerT1,
                answersCount : typeof oldOne.answersCount !== 'undefined'?oldOne.answersCount:4,
                //answersIsOpen : oldOne.answersIsOpen,
                body : oldOne.body,
                description : oldOne.description,
                //descriptionIsOpen : oldOne.descriptionIsOpen,
                newFormImg : oldOne.newFormImg,
                status : oldOne.status,
                subject_id : subject_id,
                category_id : category_id,
                subcategory_id: subcategory_id || null,
                realCategory: real_category || null,
                source_id : oldOne.source_id || null,
                isNewForm : true,
                isCopyed: true
            })
            return state.setIn(['entities', tempId], rec)
            break
        }

        case QUESTION_DELETE : {
            const {questionId} = payload
            if (state.get("trashedCursor") === questionId) {
                state = state.set("trashedCursor", null)
            }
            return state.deleteIn(['entities', questionId])
            break
        }
        case QUESTIONS_MASS_DELETE : {
            const {questionsData = []} = payload
            questionsData.forEach(function({questionId}) {
                if (state.get("trashedCursor") === questionId) {
                    state = state.set("trashedCursor", null)
                }
                state = state.deleteIn(['entities', questionId])
            })
            return state
            break
        }
        case QUESTION_SUCCESS_CREATE : {
            const {responseQuestion : {id, answerT1, ...rest}} = payload
            return state.setIn(['entities', id], new questionRecord({...rest, id, answerT1 : new answerT1Record({...answerT1})}))
            break
        }
        case QUESTIONS_STATUSES_CHANGE : {
            const {changeData} = payload
            changeData.forEach(chD => {
                const {questionId, status, syncLs = true} = chD
                state = state.setIn(['entities', questionId, "status"], status)
                if (syncLs) state = state.setIn(['entities', questionId, "_ls_status"], status)
            })
            return state
            break
        }
        case QUESTION_CHANGE_QUESTION_SOURCE : {
            const {questionId, source_id} = payload
            return state.setIn(['entities', questionId, "source_id"], source_id)
            break
        }
        case QUESTION_REMOVE_COMMENTS : {
            const {questionId, comments} = payload;
            return state.removeIn(['entities', questionId, "comments"])
            break
        }
        case QUESTION_CHANGE_COMMENTS : {
            const {questionId, comments} = payload;
            return state.setIn(['entities', questionId, "comments"], comments)
            break
        }
        case QUESTION_CHANGE_QUESTION_CATEGORY : {
            const {questionId, category_id} = payload
            return state.setIn(['entities', questionId, "category_id"], category_id)
            break
        }
        /*case CATEGORIES_ENTITIES_DELETE : {
            const {ids = []} = payload
            state.entities.valueSeq().forEach(question => {
                const {id, category_id} = question
                if (ids.includes(category_id)) {
                    state = state.deleteIn(['entities', id])
                }
                return true
            })
            return state
            break
        }*/

        case TEMP_QUESTIONS_START : {
            return state.set('tempLoading', false)
            break
        }

        case TEMP_QUESTIONS_FAIL : {
            return state
                .set('tempLoading', false)
                .set('tempLoaded', false)
            break
        }
        case TEMP_QUESTIONS_SUCCESS : {
            const {tempQuestions = []} = payload
            tempQuestions.forEach(question => {
                const {id, answerT1, ...rest} = question
                state = state.setIn(['entities', id], new questionRecord({
                    id,
                    answerT1 : new answerT1Record({...answerT1}),
                    ...rest,
                }))
            })

            state = state
                .set('tempLoading', false)
                .set('tempLoaded', true)
            return state
            break
        }

        case TRASHED_QUESTIONS_START : {
            return state.set('trashedLoading', false)
            break
        }
        case TRASHED_QUESTIONS_SUCCESS : {
            const {trashedQuestions = []} = payload
            trashedQuestions.forEach(question => {
                const {id, answerT1, ...rest} = question
                state = state.setIn(['entities', id], new questionRecord({
                    id,
                    answerT1 : new answerT1Record({...answerT1}),
                    ...rest,
                }))
            })
            state = state
                        .set('trashedLoading', false)
                        .set('trashedLoaded', true)
            return state
            break
        }
        case TRASHED_QUESTIONS_FAIL : {
            return state
                        .set('trashedLoading', false)
                        .set('trashedLoaded', false)
            break
        }
        case PUT_QUESTIONS_TO_TRASH : {
            const {trashedQuestions} = payload
            trashedQuestions.forEach(trashedQuestion => {
                const {id} = trashedQuestion
                state = state.updateIn(['entities', id], question => question.set('status', DISABLED))
            })
            return state
            break
        }
        case TRASHED_QUESTIONS_CURSOR : {
            const {trashedCursor} = payload
            return state.set('trashedCursor', trashedCursor)
            break
        }

        case TEMP_QUESTIONS_CURSOR : {
            const {tempCursor} = payload
            return state.set('tempCursor', tempCursor)
            break
        }
        case TRASHED_QUESTIONS_RECOVER : {
            const {question_id} = payload
            return state.updateIn(['entities', question_id], question => question.set('status',QUESTION_STATUSES[2].status))
            break
        }

        case TEMP_QUESTIONS_RECOVER : {
            const {question_id} = payload
            return state.updateIn(['entities', question_id], question => question.set('status',QUESTION_STATUSES[2].status))
            break
        }

        case GENERAL_STATISTIC_START : {
            return state.setIn(['generalStatistic', 'loading'], true)
            break
        }

        case GENERAL_STATISTIC_SUCCESS : {
            const {generalStatisticData = []} = payload
            state = state.setIn(['generalStatistic', 'loading'], false)
                            .setIn(['generalStatistic', 'loaded'], true)

            generalStatisticData.forEach(({status, count, iconSuffix}) => {
                state = state.setIn(['generalStatistic', 'entities', status], new statisticItemRecord({
                    status,
                    count,
                    iconSuffix
                }))
            })
            return state
            break
        }

        case GENERAL_STATISTIC_FAIL : {
            state = state.setIn(['generalStatistic', 'loading'], false)
                        .setIn(['generalStatistic', 'loaded'], false)

            return state
            break
        }

        default : {
            return state
            break
        }
    }
}

/**
 * Selectors
 * */

export const stateSelector = state => state[moduleName]
export const questionsMapSelector = createSelector(stateSelector, state => state.entities)
export const questionsSelector = createSelector(questionsMapSelector, _entities)
export const questionsWithTrashedSelector = createSelector(questionsMapSelector, _entitiesWithTrashed)

export const trashedQuestionsSelector = createSelector(questionsWithTrashedSelector, questions => questions.filter(_isTrashed))
export const trashedQuestionsSortedSelector = createSelector(trashedQuestionsSelector, questions => questions.sort(updateSortCB))

export const tempQuestionsSelector = createSelector(questionsWithTrashedSelector, questions => questions.filter(_isTemp))
export const tempQuestionsSortedSelector = createSelector(tempQuestionsSelector, questions => questions.sort(updateSortCB))
export const tempCursorSelector = createSelector(stateSelector, state => state.tempCursor)

export const trashedCursorSelector = createSelector(stateSelector, state => state.trashedCursor)

export const currentTrashedPreviewItemSelector = createSelector(questionsMapSelector, trashedCursorSelector, _getEntityWithTrashed)
export const currentTempPreviewItemSelector = createSelector(questionsMapSelector, tempCursorSelector, _getEntityWithTemp)

export const createQuestionSelector = () => questionSelector
export const createQuestionWithTrashedSelector = () => questionWithTrashedSelector
export const questionSelector = createSelector(questionsMapSelector, _getId, _getEntity)
export const questionWithTrashedSelector = createSelector(questionsMapSelector, _getId, _getEntityWithTrashed)


const _getQuestionsByCategoriesIds = (...args) => _getQuestionsAllByCategoriesIds(...args).filter(_trashedScopeCB)
const _getQuestionsAllByCategoriesIds = (questions, ids) => questions.filter(question => ids.includes(question.category_id) && !question.isNewForm)

export const questionsByCategorySelector = createSelector(questionsSelector, _getIds, (questions, ids) => _getQuestionsByCategoriesIds(questions, ids))
export const questionsByCategorySortedSelector = createSelector(questionsSelector, checkedCategoriesIdsSelector, (questions, ids) => {
    let _questions = _getQuestionsByCategoriesIds(questions, ids)
    return _questions.sort(sortQuestionsCB)
})

export const allQuestionsByCategorySelector = createSelector(questionsWithTrashedSelector, checkedCategoriesIdsSelector, (questions, ids) => _getQuestionsAllByCategoriesIds(questions, ids))

export const questionNewFormByCategorySelector = createSelector(questionsSelector, _getIds, (questions, ids) => questions.find(question => question.isNewForm && ids.includes(question.category_id)))

export const answersSelector = createSelector(questionsMapSelector, _getId, (questionsMap, id) => {
    const question = questionsMap.get(id)
    const {answersCount} = question
    return getRenderAnswers(question, answersCount)
})

export const createAnswersSelector = () => answersSelector

export const trashedLoadStateSelector = createSelector(stateSelector, state => ({loading : state.trashedLoading, loaded : state.trashedLoaded}))

export const tempLoadStateSelector = createSelector(stateSelector, state => ({loading : state.tempLoading, loaded : state.tempLoaded}))

const _readyScopeCB = question => question && question.status === QUESTION_STATUSES[1].status

export const exportListSelector = createSelector(questionsByCategorySelector, questions => questions.filter(_readyScopeCB))

const _sortStatisticCB = ({status : aStatus}, {status : bStatus}) => (QUESTION_STATUSES[bStatus] && QUESTION_STATUSES[bStatus].order || 0) - (QUESTION_STATUSES[aStatus] && QUESTION_STATUSES[aStatus].order || 0)
export const generalStatisticMapSelector = createSelector(stateSelector, state => state.generalStatistic.entities)
export const generalStatisticSelector = createSelector(generalStatisticMapSelector, map => map.valueSeq().toArray().sort(_sortStatisticCB))
export const generalStatisticLoadStateSelector = createSelector(stateSelector, state => ({loading : state.generalStatistic.loading, loaded : state.generalStatistic.loaded}))
export const checkedCategoriesStatisticMapSelector = createSelector(allQuestionsByCategorySelector, questions => {
    let acc = arrayToMap([
        {
            status : QUESTION_STATUSES[0].status,
            count : 0,
            iconSuffix : QUESTION_STATUSES[0].statisticIconClassSuffix,
        },
        {
            status : QUESTION_STATUSES[1].status,
            count : 0,
            iconSuffix : QUESTION_STATUSES[1].statisticIconClassSuffix,
        },
        {
            status : QUESTION_STATUSES[2].status,
            count : 0,
            iconSuffix : QUESTION_STATUSES[2].statisticIconClassSuffix,
        },
        {
            status : QUESTION_STATUSES[3].status,
            count : 0,
            iconSuffix : QUESTION_STATUSES[3].statisticIconClassSuffix,
        },
    ], statisticItemRecord, "status");

    return questions.reduce((acc, {status}) => {

        return acc.update(status, (stat => {

            if(stat && stat.set){
                return stat.set('count', stat.count + 1)
            }
        }))
    }, acc)
})
export const checkedCategoriesStatisticSelector = createSelector(checkedCategoriesStatisticMapSelector, map => map.valueSeq().toArray().sort(_sortStatisticCB))
export const trashedStatisticSelector = createSelector(generalStatisticSelector, statistic => statistic.find(stItem => stItem.status === QUESTION_STATUSES[0].status))
//export const tempStatisticSelector = createSelector(generalStatisticSelector, statistic => statistic.find(stItem => stItem.status === QUESTION_STATUSES[0].status))

const _statisticForRenderCB = statistic => {
    let result = statistic
        .filter(
            stat => QUESTION_STATUSES[stat.status] && QUESTION_STATUSES[stat.status].inStatistic || false
        )
    let summary = new statisticItemRecord({
        status : 'sum',
        count : result.reduce((acc, stat) => {
            acc += stat.count
            return acc
        }, 0),
        iconSuffix : 'icon-info'
    })
    return [
        ...result,
        summary
    ]
}
export const generalStatisticForRenderSelector = createSelector(generalStatisticSelector, _statisticForRenderCB)
export const checkedCategoriesStatisticForRenderSelector = createSelector(checkedCategoriesStatisticSelector, _statisticForRenderCB)



/**
 * Action Creators
 * */

export const toggleQuestionState = (params) => {
    let {questionId, toggleKey} = params
    if (!["description", "answers", 'comment'].includes(toggleKey)) return

    let field = 'answ_state';

    switch (toggleKey) {
        case 'description':
            field = 'expl_state'
            break;
        case 'comment':
            field = 'comment_state'
            break;
        default:
            break;
    }


    return {
        type : QUESTION_TOGGLE_OPEN_STATE,
        payload : {
            questionId,
            toggleKey : field,
        }
    }
}

export const questionsMassOpenState = params => {
    const {changeData = []} = params
    return {
        type : QUESTIONS_MASS_OPEN_STATE,
        payload : {
            changeData
        }
    }
}

export const resetQuestionFormState = (params) => {
    const {questionId} = params
    return {
        type : QUESTION_FORM_RESET,
        payload : {
            questionId
        }
    }
}
export const setQuestionFormErrors = (params) => {
    const {questionId, errorsData = []} = params
    return {
        type : QUESTION_FORM_ERRORS,
        payload : {
            questionId,
            errorsData,
        }
    }
}
export const setQuestionFormState = (params) => {
    const {questionId, stateData = []} = params
    return {
        type : QUESTION_FORM_STATE,
        payload : {
            questionId,
            stateData,
        }
    }
}

export const setTrashedCursor = params => {
    const {trashedQuestionId} = params
    return {
        type : TRASHED_QUESTIONS_CURSOR,
        payload : {
            trashedCursor : trashedQuestionId,
        }
    }
}

export const setTempCursor = params => {
    const {tempQuestionId} = params
    return {
        type : TEMP_QUESTIONS_CURSOR,
        payload : {
            tempCursor : tempQuestionId,
        }
    }
}

export const setAnswerCorrectness = (params) => {
    const {questionId, storeKey, isCorrect} = params
    return {
        type : SET_CORRECT_ANSWER,
        payload : {
            questionId, storeKey, isCorrect
        }
    }
}
export const changeAnswer = ({questionId, storeKey, value}) => (dispatch, getState) => {
    let {answerT1 : {correct_answer}} = questionSelector(getState(), questionId)
    if ((correct_answer === storeKey) && !value) {
        dispatch(setAnswerCorrectness({
            questionId, storeKey, isCorrect : null,
        }))
    }
    dispatch({
        type : CHANGE_ANSWER,
        payload : {
            questionId,
            storeKey,
            value,
        }
    })
}

export const changeQuestionBody = (params) => {
    const {questionId, editorState} = params
    return {
        type : CHANGE_QUESTION_BODY,
        payload : {
            questionId,
            editorState
        }
    }
}
export const changeQuestionDescription = (params) => {
    const {questionId, editorState} = params
    return {
        type : CHANGE_QUESTION_DESCRIPTION,
        payload : {
            questionId,
            editorState
        }
    }
}

export const incrAnswersCount = (questionId) => {
    return {
        type : INCREMENT_ANSWERS_COUNT,
        payload : {
            questionId,
        }
    }
}

export const deleteQuestion = (params) => {
    const {questionId, categoryId} = params
    return {
        type : QUESTION_DELETE,
        payload : {
            questionId,
            categoryId, // optional for temporary question form
        }
    }
}

export const massQuestionsDelete = params => {
    const {questionsData = []} = params
    return {
        type : QUESTIONS_MASS_DELETE,
        payload : {
            questionsData
        }
    }
}

export const putToTrash = params => {
    const {subjectId, trashedQuestions} = params
    return {
        type : PUT_QUESTIONS_TO_TRASH,
        payload : {
            subjectId,
            trashedQuestions,
        }
    }
}

export const changeQuestionsStatuses = (params) => {
    const {changeData = []} = params
    return {
        type : QUESTIONS_STATUSES_CHANGE,
        payload : {
            changeData
        }
    }
}

export const changeQuestionSource = (params) => {
    const {questionId, source_id} = params
    return {
        type : QUESTION_CHANGE_QUESTION_SOURCE,
        payload : {
            questionId,
            source_id,
        }
    }
}

export const changeQuestionCategory = (params) => {
    const {questionId, category_id, prev_category_id} = params
    return (dispatch, getState) => {
        let newCategoryId
        if (!category_id) { // could only be subcategory
            const {parent_id} = categorySelector(getState(), prev_category_id)
            if (!parent_id) { // there were no subcategory before
                newCategoryId = prev_category_id
            } else { // there were subcategory but user remove it
                newCategoryId = parent_id
            }
        } else { // could be category or subcategory
            newCategoryId = category_id
        }
        dispatch({
            type : QUESTION_CHANGE_QUESTION_CATEGORY,
            payload : {
                questionId,
                category_id : newCategoryId,
                prev_category_id,
            }
        })
    }
}

export const trashedRecover = params => {
    const {subject_id, categoryId, subcategoryId, question_id} = params
    return {
        type : TRASHED_QUESTIONS_RECOVER,
        payload : {
            subject_id,
            categoryId,
            subcategoryId,
            question_id,
        }
    }
}

export const tempRecover = params => {
    const {subject_id, categoryId, subcategoryId, question_id} = params
    return {
        type : TEMP_QUESTIONS_RECOVER,
        payload : {
            subject_id,
            categoryId,
            subcategoryId,
            question_id,
        }
    }
}

export const importQuestionsSuccess = () => ({
    type : IMPORT_QUESTIONS_SUCCESS
})


/**
* Thunk
* */
export const checkAndUploadQuestions = () => {
    return (dispatch, getState) => {
        const state = getState()

        const checkedIds = checkedCategoriesIdsSelector(state)
        const categoriesTreeMap = allCategoriesTreeMapSelector(state)
        const {id : subjectId} = currentSubjectSelector(state)
        let category_ids_for_request = []
        let requestedCategoriesForStore = []
        Object.values(categoriesTreeMap).filter(category => checkedIds.includes(category.id)).forEach(category => {
            const {id, questionsLoading, questionsLoaded, subcategories = []} = category
            if (!questionsLoading) {
                category_ids_for_request = [
                    ...category_ids_for_request,
                    id,
                ]
                requestedCategoriesForStore = [
                    ...requestedCategoriesForStore,
                    id,
                    ...subcategories.map(subcat => subcat.id),
                ]
            }
        })
        if (!category_ids_for_request.length) return

        _questionRequest({category_ids_for_request : category_ids_for_request.map(id => removePrefixCatSubcatId(id)), subjectId, requestedCategoriesForStore, dispatch})
    }
}

export const reuploadQuestions = params => (dispatch, getState) => {

    const {category_id} = params
    const state = getState()
    const category = categorySelector(state, category_id)
    if (!category) return

    _questionRequest({category_ids_for_request : [removePrefixCatSubcatId(category.id)], subjectId : category.subject_id, requestedCategoriesForStore : [category.id], dispatch})
}

const _questionRequest = params => {
    const {category_ids_for_request : category_id = [], subjectId, dispatch, requestedCategoriesForStore : requestedCategories} = params


    dispatch({
        type : QUESTIONS_START,
        payload : {
            requestedCategories,
        }
    })

    RestService.postFormData(ajaxUrls.questionsList, `Subcategory=${JSON.stringify({
        category_id,
        subcategory_id : [],
        status : []
    })}`)
        .then(middleThen)
        .then(response => {
            const {errcode, questions : questionsResponse} = response
            if (errcode !== 200) throw new Error("Failed to fetch categories") // TODO discuss possible messages from server
            let questions = []
            questionsResponse.forEach(question => {
          

                questions = [
                    ...questions,
                    getNewQuestionFromGetRepsonse({question, subjectId}),
                ]
            })
            

            dispatch({
                type : QUESTIONS_SUCCESS,
                payload : {
                    questions,
                    requestedCategories,
                }
            })
        })
        .catch(error => {
            dispatch({
                type : QUESTIONS_FAIL,
                payload : {
                    requestedCategories,
                }
            })
            console.warn(error) // TODO discuss with backend error handling
        })
}

export const createNewForm = () => {
    return (dispatch, getState) => {
        const state = getState()
        const checkedCategoriesIds = checkedCategoriesIdsSelector(state)
        const categoryCursor = categoriesCursorSelector(state)
        const sourceCursor = sourcesCursorSelector(state)
        const {id : subject_id} = currentSubjectSelector(state)
        const categoriesTree = Object.values(categoriesTreeMapSelector(state, checkedCategoriesIds))
        let firstCategory = categoriesTree.sort(sortCB)[0]
        if (firstCategory) {
            let category_id
            const {id : _category_id, subcategories} = firstCategory
            const _subcat = subcategories.find(subcat => subcat.id === categoryCursor)
            if (_subcat) category_id = _subcat.id
            else category_id = _category_id
            dispatch({
                type : QUESTION_NEW_FORM,
                payload : {
                    generateId : true,
                    initData : {
                        category_id,
                        subject_id,
                        source_id : sourceCursor,
                    }
                }
            })
        }
    }
}

export const createCopyForm = (old, params) => {
    return (dispatch, getState) => {
        const state = getState()
        const{category_id, subject_id, source_id, subcategory_id, tempId, real_category} = params
        const oldOne = old

        dispatch({
            type : QUESTION_COPY_FORM,
            payload : {
                generateId : true,
                initData : {
                    tempId: tempId,
                    category_id,
                    subject_id,
                    subcategory_id,
                    source_id,
                    oldOne,
                    real_category
                }
            }
        })
    }
}

export const handleQuestionSave = (params) => {
    const {questionId, needCheck = true} = params
    return (dispatch, getState) => {
        const state = getState()
        const question = questionSelector(state, questionId)
        if (question.isNewForm && !checkQuestionBeforeSave(question)) return
        else if (needCheck && !checkQuestionBeforeSave(question)) return
        const {body, description, difficulty, answerT1, answ_state, expl_state, comment_state, category_id : _category_id, source_id, isNewForm, status = QUESTION_STATUSES[2].status, isCopyed,
        subcategory_id: _subcategory_id, realCategory, subject_id: subj_id} = question
        const {correct_answer} = answerT1
        const {id : subjectId} = currentSubjectSelector(state)
        let category_id
        let subcategory_id
        if(!isCopyed && null === realCategory){
            let category = categorySelector(state, _category_id)
            const {parent_id} = category
            if (parent_id) {
                category_id = parent_id
                subcategory_id = _category_id
            } else {
                category_id = _category_id
                subcategory_id = ""
            }
        }
        else{
            console.log(_subcategory_id);
            if(null!==_subcategory_id){
                category_id = realCategory
                subcategory_id = _subcategory_id
            }else{
                category_id = realCategory
                subcategory_id = ""
            }
        }
        let answersForSave = getAnswersForSave(answerT1)
        if (isNewForm) {
            dispatch(qLoaderShowModal({loadingText : "Saving..."}))
        } else {
            dispatch(showLoading())
        }

        let _idDataQuestion = isNewForm ? {} : {id : questionId}
        let _idDataAnswer = isNewForm ? {} : {question_id : questionId}

        let data = new FormData()
        data.append('mcq1', JSON.stringify({
            ..._idDataQuestion,
            category_id : removePrefixCatSubcatId(category_id),
            subcategory_id : (subcategory_id ? removePrefixCatSubcatId(subcategory_id) : subcategory_id),
            source_id,
            question : body,
            description : description,
            answ_state,
            answ_state,
            difficulty,
            expl_state,
            comment_state,
            status,
            subj_id,
            answerT1 : {
                ..._idDataAnswer,
                correct_answer,
                ...answersForSave,
            },
        }))

        let url = isNewForm ? ajaxUrls.mcq1Create : ajaxUrls.mcq1Update

        dispatch({type: 'LOAD_CURSORE_SET', data: true});

        return RestService.bodyAsFormData(url, data)
            .then(middleThen)
            .then(response => {
                const {errcode, message, question : responseQuestion} = response
                if (errcode !== 200) {
                    handleQuestionSaveError({dispatch, message, questionId})
                    return
                }
                handleUpdateLastSavedQuestionData({dispatch, body, description, status, questionId}) // TODO rfc
                let answersData = getAnswersData({correct_answer, answersForSave : decodeAnswers(answersForSave)})
                console.log("🚀 ~ file: questions.js ~ line 1285 ~ return ~ answersData", answersData)

                if (isNewForm) {
                    const {id : responseId} = responseQuestion
                    const _responseQuestion = prepareNewQuestionForStore({responseQuestion, answersData, body, description, subjectId})

                    dispatch({
                        type : QUESTION_SUCCESS_CREATE,
                        payload : {
                            responseQuestion : _responseQuestion,
                        }
                    })
                    dispatch(deleteQuestion({questionId}))
                    dispatch(replaceBase64ImgSrcInEditor({questionId : responseId}))
                } else {
                    dispatch({
                        type : CHANGE_ANSWERS_DATA,
                        payload : {
                            questionId,
                            answersData,
                        }
                    })
                    dispatch(resetQuestionFormState({questionId}))
                }
            })
            .catch(error => {
                const msg = typeof error === 'object' ? error.message : typeof error === 'string' ? error : ""
                dispatch(setQuestionFormErrors({questionId, errorsData : [{key : 'backend', value : [`Form wasn't updated. ${msg}`]}]}))
                console.warn(error)
            })
            .finally(() => {
                dispatch({type: 'LOAD_CURSORE_SET', data: false});

                if (isNewForm) {
                    dispatch(qLoaderHideModal())
                } else {
                    dispatch(hideLoading())
                }
            })
    }
}

export const handleQuestionDelete = (params) => {
    const {questionId} = params
    return (dispatch, getState) => {
        const state = getState()
        const {body} = questionSelector(state, questionId)
        const {id : subjectId} = currentSubjectSelector(state)
        dispatch(showLoading())
        RestService.postFormData(ajaxUrls.mcq1Delete, `mcq1=${JSON.stringify({
            id : questionId,
            answerT1 : {
                question_id : questionId,
            }
        })}`)
            .then(middleThen)
            .then(response => {
                const {errcode, message, id : responseId} = response
                if (errcode !== 200) {
                    handleQuestionSaveError({dispatch, message, questionId})
                    return
                }
                dispatch(putToTrash({subjectId, trashedQuestions : [{id : responseId}]}))
            })
            .catch(error => {
                console.warn(error) // TODO discuss with backend error handling
            })
            .finally(() => {
                dispatch(hideLoading())
            })
    }
}

export const handleQuestionCopy = (params) => {
    const {questionId} = params
    return (dispatch, getState) => {
        const state = getState()
        dispatch(showLoading())
        return RestService.postFormData(ajaxUrls.categoriesFull, `mcq1=${JSON.stringify({
            id : questionId,
        })}`)
            .then(middleThen)
            .then(response => {
                const {errcode, message, id : responseId} = response
                if (errcode !== 200) {
                    handleQuestionSaveError({dispatch, message, questionId})
                    return
                }
                dispatch(putToTrash({subjectId, trashedQuestions : [{id : responseId}]}))
            })
            .catch(error => {
                console.warn(error) // TODO discuss with backend error handling
            })
            .finally(() => {
                dispatch(hideLoading())
            })
    }
}

export const handleResetQuestionFormState = params => {
    const {questionId} = params
    return (dispatch, getState) => {
        const state = getState()
        const question = questionSelector(state, questionId)
        if (question) dispatch(resetQuestionFormState({questionId}))
    }
}


export const handleAnswerOk = (params) => {
    const {storeKey, questionId} = params
    return (dispatch, getState) => {
        const state = getState()
        const {answerT1} = questionSelector(state, questionId)
        if (!answerT1[storeKey]) return
        dispatch(setAnswerCorrectness({
            questionId, storeKey, isCorrect : true,
        }))
    }
}


export const changeDifficulty = (params) => {
    const {questionId, editorState} = params
    return {
        type : CHANGE_QUESTION_DIFFICULTY,
        payload : {
            questionId,
            editorState
        }
    }
}

export const handleAnswerCancel = (params) => {
    const {storeKey, questionId} = params
    return (dispatch, getState) => {
        const state = getState()
        const answers = answersSelector(state, questionId)
        let answersData = []
        let removeCorrectAnswer
        let needDecrement
        answers.forEach(answer => {
            const {storeKey : answerStoreKey, text : value, isCorrect} = answer
            if (storeKey === answerStoreKey && isCorrect) {
                removeCorrectAnswer = true
                answersData = [
                    ...answersData,
                    {key : answerStoreKey, value : ""},
                ]
            } else if (storeKey === answerStoreKey) {
                answersData = [
                    ...answersData,
                    {key : answerStoreKey, value : ""}
                ]
            } else {
                answersData = [
                    ...answersData,
                    {key : answerStoreKey, value}
                ]
            }
        })
        /*
        * do recalibration if answers more than min count
        * */
        if (answersData.length > MIN_ANSWERS_COUNT) {
            let recalibrate
            answersData = answersData
                            .map(function(answD, i, arr) {
                                if (!recalibrate && !answD.value) recalibrate = true

                                if (recalibrate && i !== arr.length - 1) {
                                    return {key : `answer_${i + 1}`, value : arr[i+1].value}
                                } else if (recalibrate && i === arr.length - 1) {
                                    return { key : `answer_${i + 1}`, value : "" }
                                } else {
                                    return { key : `answer_${i + 1}`, value : answD.value }
                                }
                            })
            needDecrement = true
        }
        if (removeCorrectAnswer) answersData = [...answersData, {key : "correct_answer", value : null}]
        dispatch({
            type : CHANGE_ANSWERS_DATA,
            payload : {
                questionId,
                answersData,
            }
        })
        if (needDecrement) {
            dispatch({
                type : DECREMENT_ANSWERS_COUNT,
                payload : {
                    questionId,
                }
            })
        }

        dispatch(formValidation({questionId}))
    }
}

export const formValidation = (params) => {
    const {questionId} = params
    return (dispath, getState) => {
        const state = getState()
        const {answerT1} = questionSelector(state, questionId)

        const filledAnswersCount = getFilledAnswersCount(answerT1)

        let answersErrorsValue = []

        if (filledAnswersCount < MIN_ANSWERS_COUNT) answersErrorsValue = [...answersErrorsValue, `At least ${MIN_ANSWERS_COUNT} answers required`]
        if (!answerT1.correct_answer || !answerT1[answerT1.correct_answer]) answersErrorsValue = [...answersErrorsValue, `Correct answer is required`]

        dispath(setQuestionFormErrors({
            questionId,
            errorsData : [{key : "answers", value : answersErrorsValue}],
        }))
    }
}


export const replaceBase64ImgSrcInEditor = params => {
    const {questionId} = params
    return async function(dispatch, getState) {
        const {body, description} = questionSelector(getState(), questionId)

        let bodyHtml = await handleImageSaveAndHtmlReplacement({html : body, dispatch, questionId, editorType : "questionBody"})
        let desctiptionHtml = await handleImageSaveAndHtmlReplacement({html : description,dispatch, questionId, editorType : "questionDescription"})

        dispatch(changeQuestionBody({editorState : bodyHtml, questionId}))
        dispatch(changeQuestionDescription({editorState : desctiptionHtml, questionId}))

        dispatch(handleQuestionSave({questionId, needCheck : false}))
    }
}

export const handleImageSaveAndHtmlReplacement = async params => {
    let {html, questionId, dispatch, editorType} = params
    let resultHtml = html
    let _res
    let regexp = /src="data:image.*?"/g

    while (_res = regexp.exec(html)) {
        let dataUrl = _res[0].slice("src=\"".length, _res[0].length - 1)
        let file = dataURLtoFile(dataUrl, Date.now() + "")
        let saveData = await _imageSave({questionId, file, editorType, dispatch}).catch(error => {
            console.warn(error)
            handleQuestionSaveError({dispatch, questionId, message : "Fail to convert base64 to img file."})
        })
        const {uploadedImg : imgSrc = ""} = saveData || {}
        resultHtml = resultHtml.replace(dataUrl, imgSrc)
    }

    return resultHtml
}

export const checkAndUploadTrashed = () => {
    return (dispatch, getState) => {

        const state = getState()
        const {loaded, loading} = trashedLoadStateSelector(state)
        if (loaded || loading) return

        dispatch(_uploadTrashed())
    }
}

export const checkAndUploadTemp = () => {
    return (dispatch, getState) => {

        const state = getState()
        const {loaded, loading} = trashedLoadStateSelector(state)
        if (loading) return

        dispatch(_uploadTemp())
    }
}

export const _uploadTrashed = () => (dispatch, getState) => {
    dispatch({
        type : TRASHED_QUESTIONS_START,
    })
    RestService.postFormData(ajaxUrls.trashList, `que=${JSON.stringify({})}`)
        .then(middleThen)
        .then(response => {
            const {errcode, message, questions : questionsResponse} = response
            if (errcode !== 200) throw new Error(message || 'Fail to fetch trashed questions')

            let questions = []
            let categoriesDataObj = {}
            let sourcesDataObj = {}

            questionsResponse.forEach(question => {
                let subjectId = getSubjectIdFromTrashResponse(question)
                const questionToPush = getNewQuestionFromGetRepsonse({question, subjectId})
                const {category, source} = question
                questions = [
                    ...questions,
                    questionToPush,
                ]
                if (categoriesDataObj[subjectId]) {
                    categoriesDataObj[subjectId] = {
                        ...categoriesDataObj[subjectId],
                        categories : [
                            ...categoriesDataObj[subjectId].categories,
                            category,
                        ]
                    }
                } else {
                    categoriesDataObj[subjectId] = {
                        subjectId,
                        categories : [
                            category,
                        ]
                    }
                }
                if (source) {
                    if (sourcesDataObj[subjectId]) {
                        sourcesDataObj[subjectId] = {
                            ...sourcesDataObj[subjectId],
                            sources : [
                                ...sourcesDataObj[subjectId].sources,
                                source,
                            ]
                        }
                    } else {
                        sourcesDataObj[subjectId] = {
                            subjectId,
                            sources : [
                                source,
                            ]
                        }
                    }
                }
            })
            dispatch({
                type : TRASHED_QUESTIONS_SUCCESS,
                payload : {
                    trashedQuestions : questions,
                }
            })
            dispatch(massCategoriesSuccess({categoriesDataObj}))
            dispatch(massSourcesSucces({sourcesDataObj}))
        })
        .catch(error => {
            dispatch({
                type : TRASHED_QUESTIONS_FAIL,
            })
            console.warn(error) // TODO discuss with backend error handling
        })
}

const _uploadTemp = () => (dispatch, getState) => {
    dispatch({
        type : TEMP_QUESTIONS_START,
    })
    RestService.postFormData(ajaxUrls.tempList, `que=${JSON.stringify({})}`)
        .then(middleThen)
        .then(response => {
            const {errcode, message, questions : questionsResponse} = response
            if (errcode !== 200) throw new Error(message || 'Fail to fetch trashed questions')

            let questions = []
            let categoriesDataObj = {}
            let sourcesDataObj = {}

            questionsResponse.forEach(question => {
                let subjectId = getSubjectIdFromTrashResponse(question)
                const questionToPush = getNewQuestionFromGetRepsonse({question, subjectId})
                const {category, source} = question
                questions = [
                    ...questions,
                    questionToPush,
                ]
                if (categoriesDataObj[subjectId]) {
                    categoriesDataObj[subjectId] = {
                        ...categoriesDataObj[subjectId],
                        categories : [
                            ...categoriesDataObj[subjectId].categories,
                            category,
                        ]
                    }
                } else {
                    categoriesDataObj[subjectId] = {
                        subjectId,
                        categories : [
                            category,
                        ]
                    }
                }
                if (source) {
                    if (sourcesDataObj[subjectId]) {
                        sourcesDataObj[subjectId] = {
                            ...sourcesDataObj[subjectId],
                            sources : [
                                ...sourcesDataObj[subjectId].sources,
                                source,
                            ]
                        }
                    } else {
                        sourcesDataObj[subjectId] = {
                            subjectId,
                            sources : [
                                source,
                            ]
                        }
                    }
                }
            })
            //console.log(questions);
            dispatch({
                type : TEMP_QUESTIONS_SUCCESS,
                payload : {
                    tempQuestions : questions,
                }
            })
            if(typeof window.tempState !=='undefined'){
                if(questions.length > window.tempState){
                    window.tempState = questions.length;
                    let t = document.querySelector("#tempTicker");
                    t.innerHTML = "("+questions.length+")"
                    dispatch(
                        showModal({
                            modalType : INFO,
                            modalProps : {
                                title : "Info",
                                text : 'txtYouHaveSharedQuestions',
                                infoType : INFO_TYPE_INFO,
                            }
                        })
                    )
                }
            }
           // dispatch(massCategoriesSuccess({categoriesDataObj}))
        })
        .catch(error => {
            dispatch({
                type : TEMP_QUESTIONS_FAIL,
            })
            console.warn(error) // TODO discuss with backend error handling
        })
}
export const recoverTrash = params => {
    const {trashedQuestionId} = params
    return (dispatch, getState) => {
        dispatch(showLoading())
        RestService.postFormData(ajaxUrls.trashRecover, `que=${JSON.stringify({
            id : trashedQuestionId,
        })}`)
            .then(middleThen)
            .then(response => {
                const {errcode, message, recover} = response
                if (errcode !== 200) throw new Error(message || 'Fail to remove trashed question.')
                if (!recover)  throw new Error('Not correct response data')

                const {subject_id, category_id, subcategory_id, question_id} = recover

                const state = getState()
                let categoryId
                let subcategoryId
                if (!!+subcategory_id) { // question has subcategory
                    let _subcategoryId = setPrefixToCatSubcatId(subcategory_id, true)
                    const category = categoryWithTrashedSelector(state, _subcategoryId)
                    if (category) {
                        subcategoryId = _subcategoryId
                    } else {
                        console.warn('--- not found subcategory among local data')
                    }
                    categoryId = setPrefixToCatSubcatId(category_id, false)
                } else {
                    categoryId = setPrefixToCatSubcatId(category_id, false)
                }

                dispatch(trashedRecover({
                    subject_id,
                    categoryId,
                    subcategoryId,
                    question_id,
                }))
                dispatch(hideModal({modalType:TRASHED_QUESTION_MODAL}))
            })
            .catch(error => {
                handleQuestionSaveError({dispatch, questionId : trashedQuestionId, message : error, errorKey : 'recover'})
                console.warn(error)
            })
            .finally(() => {
                dispatch(hideLoading())
            })
    }
}

export const saveTemp = params => {
    const {tempQuestionId} = params
    return (dispatch, getState) => {
        if(!window.state || typeof window.state == 'undefined' || typeof window.state.tempForSave == 'undefined') {
            dispatch(
                showModal({
                    modalType : INFO,
                    modalProps : {
                        title : "Info",
                        text : 'txtChooseDesinationAndClickSaveAgain',
                        infoType : INFO_TYPE_ERROR,
                    }
                })
            )
            let e = document.querySelector("#shareQuestionBtn");
            return ()=>{
                e.click();
            };
        }
        dispatch(showLoading())
        //console.log(window.state.tempForSave);
        RestService.postFormData(ajaxUrls.tempSave, `que=${JSON.stringify({
            data : window.state.tempForSave,
        })}`)
            .then(middleThen)
            .then(response => {
                const {errcode, message, recover} = response
                if (errcode !== 200) throw new Error(message || 'Fail to save temp question.')
                if (!recover)  throw new Error('Not correct response data')

                const {subject_id, category_id, subcategory_id, question_id} = recover

                const state = getState()
                let categoryId
                let subcategoryId
                if (!!+subcategory_id) { // question has subcategory
                    let _subcategoryId = setPrefixToCatSubcatId(subcategory_id, true)
                    const category = categoryWithTrashedSelector(state, _subcategoryId)
                    if (category) {
                        subcategoryId = _subcategoryId
                    } else {
                        console.warn('--- not found subcategory among local data')
                    }
                    categoryId = setPrefixToCatSubcatId(category_id, false)
                } else {
                    categoryId = setPrefixToCatSubcatId(category_id, false)
                }

                dispatch(tempRecover({
                    subject_id,
                    categoryId,
                    subcategoryId,
                    question_id,
                }))
                dispatch(hideModal({modalType:TEMP_QUESTION_MODAL}))
                dispatch(checkAndUploadSources(window.state.tempForSave.subject_id))
                window.state = {};
                window.tempState >0? window.tempState --: window.tempState = 0;
            })
            .catch(error => {
                handleQuestionSaveError({dispatch, questionId : tempQuestionId, message : error, errorKey : 'tempSave'})
                console.warn(error)
            })
            .finally(() => {
                dispatch(hideLoading())
            })
    }
}

export const removeTrash = params => {
    const {trashedQuestionId} = params
    return (dispatch, getState) => {
        dispatch(showLoading())

        RestService.postFormData(ajaxUrls.trashRemove, `que=${JSON.stringify({
            id : trashedQuestionId,
        })}`)
            .then(middleThen)
            .then(response => {
                const {errcode, message} = response
                if (errcode !== 200) throw new Error(message || 'Fail to remove trashed question.')

                let {category_id : categoryId} = questionWithTrashedSelector(getState(), trashedQuestionId)
                dispatch(deleteQuestion({questionId : trashedQuestionId, categoryId}))
                dispatch(hideModal({modalType:CONFIRM}))
                dispatch(hideModal({modalType:TRASHED_QUESTION_MODAL}))
            })
            .catch(error => {
                handleQuestionSaveError({dispatch, questionId : trashedQuestionId, message : error, errorKey : 'removeErr'})
                console.warn(error)
            })
            .finally(() => {
                dispatch(hideLoading())
            })
    }
}

export const removeTemp = params => {
    const {tempQuestionId} = params
    return (dispatch, getState) => {
        dispatch(showLoading())

        RestService.postFormData(ajaxUrls.tempRemove, `que=${JSON.stringify({
            id : tempQuestionId,
        })}`)
            .then(middleThen)
            .then(response => {
                const {errcode, message} = response
                if (errcode !== 200) throw new Error(message || 'Fail to remove temp question.')

                let {category_id : categoryId} = questionWithTrashedSelector(getState(), tempQuestionId)
                dispatch(deleteQuestion({questionId : tempQuestionId, categoryId}))
                dispatch(hideModal({modalType:CONFIRM}))
                dispatch(hideModal({modalType:TEMP_QUESTION_MODAL}))
            })
            .catch(error => {
                handleQuestionSaveError({dispatch, questionId : tempQuestionId, message : error, errorKey : 'removeErr'})
                console.warn(error)
            })
            .finally(() => {
                window.tempState >0? window.tempState --: window.tempState = 0;
                dispatch(hideLoading())
            })
    }
}

export const removeAllTrash = () => (dispatch, getState) => {
    dispatch(showLoading())

    RestService.postFormData(ajaxUrls.trashRemoveAll)
        .then(middleThen)
        .then(response => {
            const {errcode, message} = response
            if (errcode !== 200) throw new Error(message || 'Fail to remove all trashed question.')
        })
        .catch(error => {
            dispatch(showModal({
                modalType : INFO_TYPE_ERROR,
                modalProps : {
                    text : formatErrorMessage(error),
                }
            }))
            console.warn(error)
        })
        .finally(() => {
            dispatch(hideModal({modalType:CONFIRM}))
            dispatch(hideLoading())

            let questionsData = []

            let trashedQuestions = trashedQuestionsSelector(getState())

            trashedQuestions.forEach(({id : questionId, category_id : categoryId}) => {
                questionsData = [
                    ...questionsData,
                    {
                        questionId,
                        categoryId
                    }
                ]
            })
            dispatch({
                type : TRASHED_QUESTIONS_START,
            })
            dispatch(massQuestionsDelete({questionsData}))
            dispatch(_uploadTrashed())
        })
}



// send files via ajax https://stackoverflow.com/a/35441898   ||   https://stackoverflow.com/a/8758614   ||   https://stackoverflow.com/a/23981045
// about boundary in fetch https://stackoverflow.com/a/39281156   !!!

export const uploadImage = (params) => {
    const {questionId, img : file, successCB, finalCB, editorType} = params
    return (dispatch, getState) => {
        const question = questionSelector(getState(), questionId)
        let {isNewForm} = question
        if (!checkUploadImg({ question, editorType, dispatch, questionId })) {
            finalCB()
            return
        }

        if (!isNewForm) {
            dispatch({
                type : UPLOADING_IMG_START,
                payload : {
                    questionId,
                }
            })
        }

        if (question.isNewForm) {
            newFormUploadImage({ file, dispatch, questionId, editorType, successCB, finalCB })
        } else {
            handleImageSave({ editorType, questionId, file, dispatch, successCB, finalCB })
        }
    }
}

export const checkUploadImg = params => {
    const {question : {body, description, uploadingImg}, editorType, dispatch, questionId} = params
    if (!['questionBody', 'questionDescription'].includes(editorType)) return false
    if (uploadingImg) return false
    var html = editorType === 'questionBody' ? body : description
    var match = html.match(/src="data:image/g)
    // if (match && match.length >= MAX_IMG_IN_QUESTION_EDITOR) {
    //     handleQuestionSaveError({dispatch, questionId, message : 'Only 3 image are allowed for question and description.'})
    //     return false
    // }
    return true
}

export const newFormUploadImage = params => {
    const {file, dispatch, questionId, editorType, successCB, finalCB} = params
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
        dispatch({
            type : NEW_FORM_TEMP_IMG,
            payload : {
                questionId,
                base64 : reader.result,
                imgFile : file,
                editorType,
            }
        })
        successCB(reader.result)
        finalCB()
    }
    reader.onerror = function (error) {
        console.warn(error)
        dispatch({
            type : UPLOADING_IMG_FAIL,
            payload : {
                questionId,
            }
        })
        handleQuestionSaveError({dispatch, questionId, message : 'Failed to convert temporary to base 64. Try to fill in question form field and than save the image.'})
        finalCB()
    }
}

export const handleImageSave = params => {
    const {editorType, questionId, file, dispatch, successCB, finalCB = ()=>{}} = params
    return _imageSave({editorType, questionId, file})
            .then(response => {
                const {uploadedImg : imgSrc} = response
                dispatch({
                    type : UPLOADING_IMG_SUCCESS,
                    payload : {
                        questionId,
                    }
                })
                successCB(imgSrc)
            })
            .catch(error => {
                console.warn(error)
                dispatch({
                    type : UPLOADING_IMG_FAIL,
                    payload : {
                        questionId,
                    }
                })
            })
            .finally(() => {
                finalCB()
            })
}

export const _imageSave = params => {
    const {editorType, questionId, file, dispatch} = params
    let data = new FormData()
    let _mediaParam = editorType === 'questionBody' ?
                        {media_1 : ""} :
                        editorType === 'questionDescription' ?
                            {media_2 : ""} :
                            {}
    data.append('mcq1', JSON.stringify({
        id : questionId,
        ..._mediaParam,
    }))
    data.append('Qupload[imageFile]', file)

    return RestService.customFetch(ajaxUrls.mcq1Upload, RestService.customFetchHeaders, data)
            .then(middleThen)
            .then(({errcode, message, ...response}) => {
                if (errcode !== 200) {
                    handleQuestionSaveError({dispatch, questionId, message})
                    throw new Error('error')
                }
                return response
            })
}


export const importSubmit = params => {
    const {category_id, subcategory_id, file, what} = params
    let data = new FormData()

    let _catParam = category_id ? {category_id : removePrefixCatSubcatId(category_id, false)} : {}
    let _subCatParam = subcategory_id ? {subcategory_id : removePrefixCatSubcatId(subcategory_id, true)} : {}

    data.append('import', JSON.stringify({
        ..._catParam,
        ..._subCatParam,
    }))

    let key = what === importQtizipId ? 'ZipUpload[zipFile]' : 'XlsUpload[xlsFile]'
    let url = what === importQtizipId ? ajaxUrls.qtiImport : ajaxUrls.xlsImport

    data.append(key, file)

    return RestService.customFetch(url, RestService.customFetchHeaders, data)
            .then(middleReduxFormThen)
            .then(response => {
                const {errcode, message} = response
                if (errcode !== 200) {
                    throw new SubmissionError({
                        _error : formatErrorMessage(message, 'Fail to import questions.'),
                    })
                } else {
                    return 'ok'
                }
            })
}

export const exportSubmit = params => {
    const {list, name, flag, what, exemplars, statusQuestion} = params

    let url
    let body

    switch (what) {
        case exportQtizipId : {
            url = ajaxUrls.qtiExport
            body = {list, name, flag, statusQuestion}
            break
        }
        case exportMspowerpointId : {
            url = ajaxUrls.pptExport
            body = {list, name, flag, statusQuestion}
            break
        }
        case exportDocxId : {
            url = ajaxUrls.examExport
            body = {list, name, flag, exemplars, type : "docx", statusQuestion}
            break
        }
        case exportPdfId : {
            url = ajaxUrls.examExport
            body = {list, name, flag, exemplars, type : "pdf", statusQuestion}
            break
        }
        default : {
            console.warn('wrong id for export')
            return
        }
    }

    return RestService.postFormData(url, `export=${JSON.stringify(body)}`)
        .then(middleReduxFormThen)
        .then(response => {
            const {errcode, message, qtizip, pptx, payload : {file} = {}} = response
            if (errcode !== 200) throw new SubmissionError({
                _error : formatErrorMessage(message) || 'Fail to export questions.',
            })
            let redirectTo
            switch (what) {
                case exportQtizipId : {
                    redirectTo = qtizip
                    break
                }
                case exportMspowerpointId : {
                    redirectTo = pptx
                    break
                }
                case exportDocxId :
                case exportPdfId : {
                    redirectTo = file
                    break
                }
                default : {
                    console.warn('wrong id for export')
                    return {}
                }
            }
            return {redirectTo}
        })
}

export const handleMassQuestionsState = submenuId => {
    return (dispatch) => {
        switch (submenuId) {
            case usedMassActionId :
            case unusedMassActionId :
            case readyForUseMassActionId : {
                dispatch(_handleAllQuestionsState(submenuId))
                break
            }
            case checkedUsedMassActionId :
            case checkedUnusedMassActionId :
            case checkedReadyForUseMassActionId :
            case hideCheckedAnswersMassActionId :
            case showCheckedAnswersMassActionId :
            case hideCheckedExplanationMassActionId :
            case showCheckedExplanationMassActionId : {
                dispatch(_handleCheckedQuestionsState(submenuId))
                break
            }
            default : {
                return
                break
            }
        }
    }
}

const _handleAllQuestionsState = (submenuId) => {
    return (dispatch, getState) => {
        const state = getState()
        const currentSubject = currentSubjectSelector(state)
        if (!currentSubject) {
            errorModalCatch({dispatch})(`Please, select any subject first.`)
            return
        }

        let status = getStatus(submenuId)
        if (!status) {
            console.warn('no status found')
            return
        }
        let confirmText = getConfirmationText(submenuId)
        if (!confirmText) {
            console.warn('no confirm text')
            return
        }

        dispatch(showModal({
            modalType : CONFIRM,
            modalProps : {
                title : "Mass change status in subject",
                confirmText : confirmText,
                okButtonTxt : "Yes",
                cancelButtonTxt : "No",
                okCb : () => {
                    let data = new FormData()

                    let {id : subjectid} = currentSubject

                    data.append('mcq1', JSON.stringify({
                        subjectid,
                        status,
                    }))

                    return RestService.customFetch(ajaxUrls.mcq1QuestionInSubject, RestService.customFetchHeaders, data)
                        .then(middleThen)
                        .then(massQuestionsStatusKeysChangeThen({questionNotFoundError : true, submenuId, getState, dispatch, status, statusKey : "status"}))
                        .then(successModalThen({dispatch, message : getSuccesMsg(submenuId)}))
                        .catch(errorModalCatch({dispatch}))
                        .finally(() => {
                            dispatch(hideModal({modalType:CONFIRM}))
                        })
                },
            }
        }))
    }
}

const _handleCheckedQuestionsState = (submenuId) => {
    return (dispatch, getState) => {
        const state = getState()
        const checkedCategoriesIds = checkedCategoriesIdsSelector(state)
        const categories = checkedCategoriesSelector(state)
        const questions = questionsByCategorySelector(state, checkedCategoriesIds)
        if (!questions.length) {
            errorModalCatch({dispatch})(`Please, check category with at least one question.`)
            return
        }
        let confirmText = getConfirmationText(submenuId)
        if (!confirmText) {
            console.warn('no confirm text')
            return
        }

        dispatch(showModal({
            modalType : CONFIRM,
            modalProps : {
                title : "Mass change status in category(ies)",
                confirmText : confirmText,
                okButtonTxt : "Yes",
                cancelButtonTxt : "No",
                okCb : () => {
                    let __categories = categories.filter(category => !category.parent_id)
                    let __subcategories = categories.filter(category => category.parent_id)

                    let __categoriesIds = __categories.map(__category => removePrefixCatSubcatId(__category.id))
                    let __subcategoriesIds = __subcategories.map(__subcategory => removePrefixCatSubcatId(__subcategory.id))


                    let statusKeyValue
                    let catKeyValue = {categoryid : __categoriesIds, subcategoryid : __subcategoriesIds}
                    let subcatKeyValue = {subcategoryid : __subcategoriesIds}
                    let promises = []
                    let __catPromise
                    let __subcatPromise

                    switch (submenuId) {
                        case checkedUsedMassActionId :
                        case checkedUnusedMassActionId :
                        case checkedReadyForUseMassActionId : {
                            let status = getStatus(submenuId)
                            statusKeyValue = {status}

                            if (__categoriesIds.length) {
                                let data = new FormData()
                                data.append('mcq1', JSON.stringify({
                                    ...catKeyValue,
                                    ...statusKeyValue,
                                }))
                                __catPromise = RestService.customFetch(ajaxUrls.mcq1QuestionInCategory, RestService.customFetchHeaders, data)
                                    .then(middleThen)
                                    .then(massQuestionsStatusKeysChangeThen({submenuId, getState, dispatch, status, statusKey : "status"}))

                            }
                            if (__subcategoriesIds.length) {
                                let data = new FormData()
                                data.append('mcq1', JSON.stringify({
                                    ...subcatKeyValue,
                                    ...statusKeyValue,
                                }))
                                __subcatPromise = RestService.customFetch(ajaxUrls.mcq1QuestionInSubcategory, RestService.customFetchHeaders, data)
                                    .then(middleThen)
                                    .then(massQuestionsStatusKeysChangeThen({submenuId, getState, dispatch, status, statusKey : "status"}))
                            }

                            break
                        }
                        case hideCheckedAnswersMassActionId :
                        case showCheckedAnswersMassActionId :
                        case hideCheckedExplanationMassActionId :
                        case showCheckedExplanationMassActionId : {
                            let status = (submenuId === hideCheckedAnswersMassActionId || submenuId === hideCheckedExplanationMassActionId) ?
                                0 :
                                1
                            let statusKey = (submenuId === hideCheckedAnswersMassActionId || submenuId === showCheckedAnswersMassActionId) ?
                                "answ_state" :
                                "expl_state"

                            statusKeyValue = {[statusKey] : status}

                            if (__categoriesIds.length) {
                                let data = new FormData()
                                data.append('mcq1', JSON.stringify({
                                    ...catKeyValue,
                                    ...statusKeyValue,
                                }))
                                __catPromise = RestService.customFetch(ajaxUrls.mcq1StateInCategory, RestService.customFetchHeaders, data)
                                    .then(middleThen)
                                    .then(massQuestionsStatusKeysChangeThen({submenuId, getState, dispatch, status, statusKey}))
                            }
                            if (__subcategoriesIds.length) {
                                let data = new FormData()
                                data.append('mcq1', JSON.stringify({
                                    ...subcatKeyValue,
                                    ...statusKeyValue,
                                }))
                                __subcatPromise = RestService.customFetch(ajaxUrls.mcq1StateInSubcategory, RestService.customFetchHeaders, data)
                                    .then(middleThen)
                                    .then(massQuestionsStatusKeysChangeThen({submenuId, getState, dispatch, status, statusKey}))
                            }

                            break
                        }
                        default : {
                            return
                            break
                        }
                    }

                    if (__catPromise) promises = [...promises, __catPromise]
                    if (__subcatPromise) promises = [...promises, __subcatPromise]

                    Promise.all(promises)
                        .then(successModalThen({dispatch, message : getSuccesMsg(submenuId)}))
                        .catch(errorModalCatch({dispatch}))
                        .finally(() => {
                            dispatch(hideModal({modalType:CONFIRM}))
                        })
                }
            }
        }))
    }
}

export const checkAndUploadGeneralStatistic = (force) => (dispatch, getState) => {
    let {loading, loaded} = generalStatisticLoadStateSelector(getState())
    
    if (loading) return
    if (!force && loaded) return

    dispatch({
        type : GENERAL_STATISTIC_START
    })

    RestService.customFetch(ajaxUrls.statisticStatuses, RestService.customFetchHeaders)
        .then(middleThen)
        .then((response) => {
            let {errcode, message} = response
            if (errcode !== 200)  throw new Error('fail to fetch general statistic')

            dispatch({
                type : GENERAL_STATISTIC_SUCCESS,
                payload : {
                    generalStatisticData : message.map(item => ({
                        ...item,
                        count : +item.count,
                        iconSuffix : QUESTION_STATUSES[item.status] && QUESTION_STATUSES[item.status].statisticIconClassSuffix || '',
                    }))
                }
            })
        })
        .catch(error => {
            console.warn(error)
            dispatch({
                type : GENERAL_STATISTIC_FAIL
            })
        })
}

export const handleSendQuestion = (params) => {
    const {name, qbmId} = params
    let data = new FormData()
    data.append('data', JSON.stringify({name:name, id:qbmId}))
    return RestService.bodyAsFormData(ajaxUrls.mcq1Send, data)
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, subject, message} = res
            if (errcode === 200) {
                return true
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

/**
* utils
**/

export {populateStoreKeysFromMinLength, canIncrementAnswers, sortQuestionsCB} from './_utils'


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/questions.js